var map = {
	"./Covd-19 Section": 145,
	"./Covd-19 Section.svg": 145,
	"./Group 1": 146,
	"./Group 1.svg": 146,
	"./Group 3": 147,
	"./Group 3.svg": 147,
	"./Group 4": 148,
	"./Group 4.svg": 148,
	"./Lab-Logo": 149,
	"./Lab-Logo.svg": 149,
	"./LabTestsLogo": 150,
	"./LabTestsLogo.png": 150,
	"./TestsInc. Logo 1": 151,
	"./TestsInc. Logo 1.svg": 151,
	"./certification": 152,
	"./certification.svg": 152,
	"./check_circle_outline-black-48dp": 153,
	"./check_circle_outline-black-48dp.svg": 153,
	"./graph": 154,
	"./graph.png": 154,
	"./heart": 155,
	"./heart.svg": 155,
	"./logo-old": 156,
	"./logo-old.png": 156,
	"./qrcode": 157,
	"./qrcode.jpeg": 157,
	"./radio_button_unchecked-24px 1": 158,
	"./radio_button_unchecked-24px 1.svg": 158,
	"./sec1": 159,
	"./sec1.svg": 159,
	"./sec2bg": 160,
	"./sec2bg.svg": 160,
	"./sec4bg": 161,
	"./sec4bg.svg": 161,
	"./tests_inc_5_200x200": 162,
	"./tests_inc_5_200x200.png": 162,
	"./tests_inc_5_200x2001": 163,
	"./tests_inc_5_200x2001.png": 163,
	"./websiteQRCode_noFrame": 164,
	"./websiteQRCode_noFrame.png": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;